<template>
  <article v-if="!removed" class="p-4">
    <div class="flex space-x-3 rtl:space-x-reverse">
      <div class="w-10 lg:w-16">
        <StoreProductMedia
          :value="media"
          ratio
          :alt="name"
          :class="{ 'opacity-30': noStock }"
        />
      </div>
      <div class="flex-grow" :class="{ 'opacity-30': noStock }">
        <h3 class="text-sm leading-snug break-word">{{ name }}</h3>

        <!-- Price -->
        <div class="flex items-center">
          <p class="text-xs text-gray-500 me-1">{{ $t("price") }}:</p>

          <div class="flex">
            <Amount class="text-xs text-gray-500" :value="price" />
            <Amount
              v-if="regularPrice"
              class="text-xs text-gray-500 line-through ms-1"
              :value="regularPrice"
            />
            <span v-if="discount" class="text-xs text-warning-500 ms-2">
              {{ discount }}% {{ $t("off") }}
            </span>
          </div>
        </div>

        <p v-if="measurement" class="text-xs text-gray-500">
          {{ measurement }}
        </p>

        <!-- Attributes -->
        <template v-if="attributes.length > 0">
          <p
            v-for="attr in attributes"
            :key="attr.label"
            class="text-xs text-gray-500"
          >
            {{ attr.label }}: {{ attr.value }}
          </p>
        </template>
      </div>
      <div class="flex flex-col items-end text-end">
        <div v-if="noStock">
          <p class="text-xs text-danger-500">This item is out of stock</p>

          <!-- TODO: REMOVE FROM SERVER CART -->
          <VyButton
            class="mt-2"
            size="sm"
            color="danger"
            shape="rounded"
            theme="muted"
            :label="$t('remove')"
            @click="removed = true"
          />
        </div>

        <template v-else>
          <Amount
            v-if="regularSubTotal"
            class="text-xs leading-none text-gray-500 line-through"
            :value="regularSubTotal"
          />
          <Amount class="mt-1 font-bold leading-none" :value="subTotal" />
        </template>
      </div>
    </div>

    <StoreProductCharges :value="charges" />

    <div v-if="!noStock" class="mt-3">
      <StoreCartAddToCart
        :id="id"
        class="w-fit"
        :max="stock"
        :is-out-of-stock="isOutOfStock"
        :allow-qty="allowQty"
        :type="type"
        :manage-inventory="manageInventory"
        :message="message"
        @change="$emit('refresh')"
      />
      <p v-if="message" class="mt-2 text-xs text-warning-500">
        {{ message }}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    id: { type: Number, default: null },
    name: { type: String, default: null },
    media: { type: Array, default: null },
    price: { type: Number, default: null },
    regularPrice: { type: Number, default: null },
    type: { type: String, default: null },
    measurement: { type: String, default: null },
    stock: { type: Number, default: null },
    isOutOfStock: Boolean,
    allowQty: Boolean,
    charges: { type: Array, default: null },
    message: { type: String, default: null },
    variant: { type: Object, default: null },
    subTotal: { type: Number, default: null },
    regularSubTotal: { type: Number, default: null },
    manageInventory: Boolean,
  },
  emits: ["refresh"],
  data() {
    return {
      /**
       * When the localStorage cart has the product but API returns outOfStock,
       * cart item will show warning and ask user to hide the item from cart.
       */
      removed: false,
    };
  },

  computed: {
    // ...mapState(useCartStore, [{ productInCart: product }]),

    productLink() {
      return { name: "biz-products-slug", params: { slug: this.id } };
    },

    noStock() {
      return (
        this.isOutOfStock === true ||
        (this.manageInventory && this.stock && this.stock <= 0)
      );
    },

    attributes() {
      if (this.variant) {
        return this.variant.attributes.map((attr) => {
          return {
            label: attr.attribute.name,
            value: attr.option.label,
          };
        });
      }
      return [];
    },
    discount() {
      const price = Number(this.price);
      const regularPrice = Number(this.regularPrice);
      if (!price || price > regularPrice) {
        return null;
      }
      return parseInt(100 - (price * 100) / regularPrice);
    },
  },
};
</script>
